import { http } from "./http";

export type FlowKind = "ECHEANCE" | "RETARD" | "PAIE" | "CHARGE";

export interface TreasuryForecast {
  /** false tant que le solde de départ n'a pas été saisi. */
  configured: boolean;
  today: string;
  horizon: number;
  opening: { amount: number; date: string } | null;
  /** Solde de départ + recettes − dépenses enregistrées depuis. */
  currentBalance: number;
  /** Part du dû payée à l'échéance, puis sous 30 et sous 60 jours (mesurée ou hypothèse par défaut). */
  behaviour: { onTime: number; within30: number; within60: number; source: "history" | "default"; sample: number };
  days: Array<{ date: string; inflow: number; outflow: number; balance: number }>;
  flows: Array<{ date: string; kind: FlowKind; label: string; amount: number }>;
  inflow: number;
  outflow: number;
  endBalance: number;
  minBalance: number;
  minDate: string;
  firstNegativeDate: string | null;
  /** Retards de plus de 60 jours, non comptés. */
  doubtful: number;
}

export function getForecast(days: 30 | 60 | 90): Promise<TreasuryForecast> {
  return http.get<TreasuryForecast>("/treasury/forecast", { days });
}

export function setOpening(amount: number, date: string): Promise<{ amount: number; date: string }> {
  return http.put<{ amount: number; date: string }>("/treasury/opening", { amount, date });
}
